import React from 'react';
import axios from 'axios';
import debounce from 'lodash/debounce';

import SearchInputItem from './SearchInputItem.jsx';

export default class SearchBlock extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            results: []
        }

        this.fetchResults = this.fetchResults.bind(this);
        this.handleServiceClick = this.handleServiceClick.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);

        this.delayedFetchResults = debounce(this.fetchResults, 500);
    }

    handleServiceClick(item) {
        this.props.addServiceHandler(item);
    }

    componentDidMount() {
        if (this.props.inputText.length > 0) {
            this.fetchResults({
                target: {
                    value: this.props.inputText
                }
            })
        }
    }

    resultItems() {
        return this.state.results.map((item, index) => {
            return (
                <SearchInputItem key={index} item={item} clickHandler={this.handleServiceClick} />
            )
        });
    }

    normalizeExtras(service) {
        let newExtras = [];
        if (service.upsells) {
            service.upsells.forEach((item) => {
                newExtras.push({
                    title: item.title,
                    price: item.price,
                })
            })
        }
        return newExtras;
    }

    fetchResults(e) {
        this.setState({
            loading: true
        });
        const that = this;
        axios.get(WPURLS.siteurl + '/wp-json/wp/v2/service?per_page=100&search=' + e.target.value)
            .then(function (response) {
                const results = response.data.map((item) => {
                    return {
                        wpid: item.id,
                        id: item.id,
                        title: item.title.rendered,
                        description: item.content.rendered,
                        price: {
                            value: item.price.value,
                            append: item.price.append,
                            prepend: item.price.prepend
                        },
                        sales_price: {
                            value: item.sales_price && item.sales_price.value || 0,
                            append: item.sales_price && item.sales_price.append || '',
                            prepend: item.sales_price && item.sales_price.prepend || ''
                        },
                        is_on_sale: item.is_on_sale,
                        is_hidden_from_list: item.is_hidden_from_list,
                        duration: {
                            value: item.duration.value,
                            append: item.duration.append
                        },
                        instructions: item.instructions && item.instructions.value,
                        category: item.category,
                        extras: that.normalizeExtras(item)
                    }
                })
                that.setState({ results: results, loading: false })
            })
            .catch(function (error) {
                console.log(error);
                that.setState({loading: false});
            });
    }

    handleInputChange(event) {
        event.persist()
        this.delayedFetchResults(event)
    }

    results() {
        if (this.state.loading) {
           return (
               <div className='text-center p-4'>Searching...</div>
           );
        } else if (this.state.results.length > 0) {
            return this.resultItems();
        } else {
            return <div className='text-center p-4'>Not services found. Try adjust search.</div>;
        }
    }

    render() {
        const errorClass = this.props.error ? "error" : "";
        const classes = "search-input flex items-center " + errorClass;

        return (
            <>
                <div className={classes}>
                    <i className="search-input__icon fas fa-search"></i>
                    <input
                        type="text"
                        placeholder={this.props.placeholder}
                        onClick={this.showResults}
                        onKeyUp={this.handleInputChange}
                        defaultValue={this.props.inputText}
                    />
                </div>
                <div className="search-input__inline-results">
                    <div>
                        { this.results() }
                    </div>
                </div>
            </>
        )
    }
}



// WEBPACK FOOTER //
// ./scripts/components/SearchBlock.jsx